export default "__VITE_ASSET__jCBfCke6__"